/**
 * Takes an array of items and a condition that each element will be evaluated against
 * returns 2 arrays: one with the elements that have the condition evaluated as true and
 * another one with the elements that have the condition evaluated as false
 * @example
 * const [ pageAccessPermissions, dataSourcesPermissions] = dividePermissionArrayByType(permissions, e => e.rsp_rbac);
 * Takes an array of permissions and sorts them into 2 arrays, one has elements that have rsp_rbac flag as true and another one as false
 * @param {Array} list - array of elements
 * @param {Function} - condition to evaluate each element against
 */

export function dividePermissionArrayByType(array, isValid) {
  return array.reduce(
    ([pass, fail], elem) => {
      return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    },
    [[], []],
  );
}
